<div class="stats-row">
  <div class="gauge-block">
    <app-analyst-gauge
      [value]="gaugeValue"
      [sellValue]="sellGaugeValue"
      [size]="44"
      [strokeWidth]="6"
      positiveColor="var(--v3-positive)"
      negativeColor="var(--v3-negative)"
    ></app-analyst-gauge>
    <div class="rating-info">
      <span class="rating" [class.negative]="!isPositive">{{ rating }}</span>
      <span class="counts">{{ buyCount }} Buy · {{ holdCount }} Hold · {{ sellCount }} Sell</span>
    </div>
  </div>
  <div class="potential-block">
    <span
      class="potential-value"
      [class.positive]="potential !== null && potential >= 0"
      [class.negative]="potential !== null && potential < 0"
    >
      @if (potential !== null) {
        {{ potential >= 0 ? '+' : ''
        }}<span class="count" [appCountUp]="potential" [decimals]="2"></span
        ><span class="unit">%</span>
      } @else {
        —
      }
    </span>
    <span class="potential-label">Potenzial zum Ø-Kursziel</span>
  </div>
</div>
